'use strict';

const Reflux = require('@muzzylane/reflux');
const _ = {
    findLast:       require('lodash/findLast'),
}

const Globals = require('../../../app/globals');

const ServerRequest = require('../actions/request');
const ForgeError = require('../util/error');
const ErrorConsts = require('../constants/error');
const SignInActions = require('../actions/sign_in_actions');
const GlobalUserActions = require('../actions/GlobalUserActions');

let users = {};
let action = {};
let error = {};
let emailAvailability = {};
let comments = [];
let feedback_categories = null;
let userActionHistory = {};

const GlobalUserStore = Reflux.createStore({
    listenables: [GlobalUserActions, SignInActions],

    init: function() {},

    resetState: function() {
        users = {};
        comments = [];
        feedback_categories = null;
        userActionHistory = {};
    },

    onSignOutCompleted: function(res) {
        this.resetState();
        this.emitStatus();
    },

    onSignOutFailed: function(err) {
        console.warn(err);
        this.resetState();
        this.emitStatus();
    },

    getState: function() {
        return {
            users: users,
            action: action,
            emailAvailability: emailAvailability,
            comments: comments,
            feedback_categories: feedback_categories,
            userActionHistory,
            error: error
        }
    },
    
    getLastLogin: function(userId) {
        let actionHistory = userActionHistory[userId];
        if (actionHistory && actionHistory.action_history) {
            return _.findLast(actionHistory.action_history,{action_type:Globals.user_actions.type.USER_LOGIN});
        }
    },

    emitStatus: function() {
        this.trigger(this.getState());
        action = {};
        //error = {}; //maybe?
    },

    onError: function(actionId, err) {
        action = { id: actionId };
        if (err.status) {
            switch (err.status) {
                default:
                    action.error = new ForgeError({ message: ErrorConsts.INTERNAL_GENERAL, stack: err.responseText || null });
            }
        }
        else {
            action.error = err;
        }

        this.emitStatus();
    },

    onGetInfoCompleted: function(actionId, userId, userInfo) {
        // console.log("onGetInfoCompleted: ", actionId, userId, userInfo);
        action = { id: actionId };
        users[userInfo.id] = userInfo;
        this.emitStatus();
    },

    onGetInfoFailed: function(actionId, userId, err) {
        console.warn("onGetInfoFailed: ", actionId, userId, err);
        this.onError(actionId, err);
    },

    onGetInfosCompleted: function(actionId, userIds, userInfos) {
        // console.log("onGetInfosCompleted: ", actionId, userId, userInfos);
        action = { id: actionId };
        userInfos.forEach((userInfo) => {
            users[userInfo.id] = userInfo;
        });
        this.emitStatus();
    },

    onGetInfosFailed: function(actionId, userIds, err) {
        console.warn("onGetInfosFailed: ", actionId, userIds, err);
        this.onError(actionId, err);
    },

    onGetAvailableCompleted: function(actionId, email, res) {
        action = { id: actionId };
        emailAvailability[email] = { available: true, message: null };
        this.emitStatus();
    },

    onGetAvailableFailed: function(actionId, email, err) {
        action = { id: actionId, error: err }; // don't really need this.

        let message;
        if (err.status >= 500) {
            message = 'Error. Please try again later.';
        }
        else {
            message = err.responseText;
        }

        emailAvailability[email] = { available: false, message: message };
        this.emitStatus();
    },
    
    onGetCommentsCompleted: function(actionId, res) {
        action = { id: actionId };
        comments = res
        this.emitStatus();
    },

    onGetCommentsFailed: function(actionId, err) {
        console.warn('onGetCommentsFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
    onGetStudentFeedbackCategoriesCompleted: function(actionId, res) {
        // console.log('onGetStudentFeedbackCategoriesCompleted: ', actionId, res);
        action = { id: actionId };
        feedback_categories = res;
        this.emitStatus();
    },

    onGetStudentFeedbackCategoriesFailed: function(actionId, err) {
        console.warn('onGetStudentFeedbackCategoriesFailed: ', actionId, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },

    onGetActionHistoryCompleted: function(actionId, params, res) {
        action = { id: actionId };
        let { userId, dayRange } = params;
        userActionHistory[userId] = {
            action_history: res,
            dayRange
        }
        this.emitStatus();
    },
    onGetActionHistoryFailed: function(actionId, params, err) {
        console.warn('onGetActionHistoryFailed', actionId, params, err);
        action = { id: actionId, error: err };
        this.emitStatus();
    },
    
});

module.exports = GlobalUserStore;
